import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import createPersistedState from 'vuex-persistedstate'

import {
  Firebase,
  db
  // storiesRef,
  // usersRef
} from '../firebaseDB'

Vue.use(Vuex)

let initialState = () => ({
  user: null,
  profile: {
    bio: '',
    role: '',
    name: '',
    birthday: '',
    gender: '',
    hometown: '',
    location: '',
    picture_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Default_profile_picture_%28male%29_on_Facebook.jpg/900px-Default_profile_picture_%28male%29_on_Facebook.jpg'
  },
  error: null,
  loading: false,
  selectedStory: null,
  stories: [],
  check_Password: true,
  updatedPassword: false,
  changePassword: false,
  ChangePasswordError: null
})

export const store = new Vuex.Store({
  state: initialState,
  plugins: [createPersistedState],
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setStories (state, payload) {
      state.stories = payload
    },
    setSelectedStory (state, payload) {
      state.selectedStory = payload
    },
    addNewNode (state, payload) {
      state.stories.filter(story => story.title === payload.title)[0].diagramData.nodeDataArray = payload.nodeData
    },
    fbSetProfile (state, payload) {
      state.profile.name = payload.name
      state.profile.birthday = payload.birthday
      state.profile.gender = payload.gender
      state.profile.hometown = payload.hometown.name
      state.profile.location = payload.location.name
      state.profile.picture_url = payload.picture.data.url
    },
    setCurrentNode (state, payload) {
      state.currentNode = payload.currentNode
    },
    setCheckPassword (state, payload) {
      state.check_Password = payload
    },
    setUpdatedPassword (state, payload) {
      state.updatedPassword = payload
    },
    setChangePassword (state, payload) {
      state.changePassword = payload
    },
    setChangePasswordError (state, payload) {
      state.ChangePasswordError = payload
    }
  },
  actions: {
    userSignUp ({commit}, payload) {
      commit('setLoading', true)
      const usersRef = db.ref().child('users')

      // create account
      Firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          const user = Firebase.auth().currentUser
          user.sendEmailVerification().then(function () {
            usersRef.update({
              [firebaseUser.uid]: {
                email: String([firebaseUser.email])
              }
            })
            commit('setLoading', false)
          }, function (error) {
            commit('setError', error)
            commit('setLoading', false)
          })
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },
    userSignIn ({commit, dispatch}, payload) {
      commit('setLoading', true)

      // sign in with credentials
      Firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          if (firebaseUser.user.emailVerified) {
            commit('setUser', { email: firebaseUser.user.email })
            commit('setLoading', false)
            commit('setError', null)
            store.state.user = { ...store.state.user,
              id: firebaseUser.user.uid
            }
            dispatch('pullStories')
            dispatch('pullProfile')

            // go to home
            router.push('/home')
          } else {
            commit('setError', 'Please verify your email first')
            commit('setLoading', false)
          }
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },
    autoSignIn ({commit, dispatch}, payload) {
      commit('setUser', {
        email: payload.email
      })
      // add email hash (id) to user object
      store.state.user = { ...store.state.user,
        id: Firebase.auth().currentUser.uid
      }
      dispatch('pullStories')
      dispatch('pullProfile')
    },
    userSignOut ({commit}) {
      Firebase.auth().signOut()
      commit('setUser', null)
      store.replaceState(initialState())
      router.push('/')
    },
    resetPassword ({commit}, payload) {
      commit('setLoading', true)
      Firebase.auth().sendPasswordResetEmail(payload.email)
        .then(() => {
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
        })
    },
    changePassword ({commit}, payload) {
      commit('setChangePassword', true)
      let user = Firebase.auth().currentUser
      let credential = Firebase.auth.EmailAuthProvider.credential(
        Firebase.auth().currentUser.email,
        payload.password
      )
      // Prompt the user to re-provide their sign-in credentials
      user.reauthenticateWithCredential(credential).then(function () {
        // cur_password matched
        commit('setCheckPassword', true)
        user.updatePassword(payload.newPassword).then(function () {
          // successfully update the password
          commit('setUpdatedPassword', true)
          setTimeout(() => commit('setUpdatedPassword', false), 1000)
        }).catch(function (error) {
          // failed to update the password
          commit('setUpdatedPassword', false)
          commit('setCheckPassword', false)
          commit('error', error.message)
        })
        commit('setChangePassword', false)
      }).catch(function (error) {
        commit('error', error.message)
        if (error.code === 'auth/wrong-password') {
          // cur_password unmatched
          commit('setCheckPassword', false)
          commit('setUpdatedPassword', false)
          setTimeout(() => {
            commit('setCheckPassword', true)
          }, 1000)
        }
        commit('setChangePassword', false)
      })
    },
    addNode ({commit, dispatch}, payload) {
      commit('addNewNode', payload)
      // dispatch('pullStories')
    },
    SaveToDB ({dispatch}, payload) {
      // This is wraped interface to save sotries info to firebase
      // Synchronize cached data with firebase after every change
      // @payload: {refPath: , newData: }
      db.ref(payload.refPath).set(payload.newData)
      dispatch('pullStories')
    },
    pullStories ({commit}) {
      // get stories from db
      let usRef = db.ref().child('users/' + store.state.user.id + '/stories')
      usRef.once('value').then(snapshot => {
        let storyKeys = []
        if (snapshot.val()) {
          storyKeys = Object.keys(snapshot.val())
        } else {
          store.state.stories = []
        }
        let stories = []
        for (let i = 0; i < storyKeys.length; i++) {
          let tRef = db.ref().child('stories/' + storyKeys[i])
          tRef.once('value').then(snapshot => {
            let cur = snapshot.val()
            try {
              cur['key'] = snapshot.key
              stories.push(cur)
            } catch (err) { }
          })
        }
        commit('setStories', stories)
      })
    },
    // Todo
    pullProfile () {
      let proRef = db.ref().child('users/' + store.state.user.id + '/profile')
      proRef.on('value', (snapshot) => {
        if (snapshot.val()) {
          // console.log(snapshot.val())
          store.state.profile = snapshot.val()
        }
        // } else { console.log('no profile') }
      })
    },
    // Todo
    pushProfile () {
      let proRef = db.ref().child('users/' + store.state.user.id + '/profile')
      proRef.set(store.state.profile)
    },
    // Todo
    fbLogin ({commit}) {
      // eslint-disable-next-line
      FB.logout((response) => {
        // user is now logged out
      })
      // eslint-disable-next-line
      FB.login((response) => {
        if (response.authResponse) {
          console.log('Welcome!  Fetching your information.... ')
          // eslint-disable-next-line
          FB.api('/me',
          {fields: 'friends,name,likes,birthday,hometown,gender,location,picture'},
          (response) => {
            // set store values
            commit('fbSetProfile', response)
          })
          // eslint-disable-next-line
          FB.logout((response) => {
            // user is now logged out
          })
        } else {
          console.log('User cancelled login or did not fully authorize.')
        }
      }, {scope: 'user_likes,user_birthday,user_hometown,user_age_range,user_friends,user_gender,user_location', return_scopes: 'true'})
    },
    // Todo
    fbAuth ({
      commit
    }) {
      let provider = new Firebase.auth.FacebookAuthProvider()
      provider.addScope('user_birthday')
      provider.addScope('user_hometown')
      provider.addScope('user_age_range')
      provider.addScope('user_friends')
      provider.addScope('user_gender')
      provider.addScope('user_location')

      Firebase.auth().signInWithPopup(provider).then((result) => {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        // let token = result.credential.accessToken
        // The signed-in user info.
        // let user = result.user
        // ...
      }).catch((error) => {
        // Handle Errors here.
        let errorCode = error.code
        let errorMessage = error.message
        // The email of the user's account used.
        let email = error.email
        // The firebase.auth.AuthCredential type that was used.
        let credential = error.credential
        // ...
        console.log(errorCode)
        console.log(errorMessage)
        console.log(email)
        console.log(credential)
      })
    },
    selectedStory ({commit}, payload) {
      commit('setSelectedStory', payload)
    }
  },

  getters: {
    isAuthenticated (state) {
      return state.user !== null &&
        state.user !== undefined &&
        Firebase.auth().currentUser.emailVerified === true
    },
    exsistingStories (state) {
      return state.stories
    },
    getStory (state) {
      return state.stories.filter(story => story.title === state.selectedStory)[0]
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js